import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {blueColor, greyishBlue500} from "assets/jss/main";
import Badge from "../../../../../../../../../components/Badge";
import {PackingContext} from "../../../../PackingContext";
import CarrierIcon from "./CarrierIcon";
import {Grid} from "@mui/material";
import {packingStepNames} from "../../../../packingSteps";

ShipmentInfosHeader.propTypes = {
    selectedShipment: PropTypes.object.isRequired
};

function ShipmentInfosHeader({selectedShipment}) {
    const {isMultiSessionPacking, packingStep, currentWorkstation} = useContext(PackingContext)

    return (
        <Grid
            container
            direction={'column'}
            gap={"8px"}
            sx={{
                marginLeft: "16px",
                maxWidth: "100%"
            }}
        >
            <Grid
                container
                direction={'column'}
            >
                <span style={{fontWeight: 600, fontSize: "16px", color: blueColor}}>#{selectedShipment.orderNumber}</span>
                {selectedShipment.lineItems.length > 1 && (
                    <span style={{fontWeight: 400, fontSize: "14px", color: greyishBlue500}}>
                    {selectedShipment.lineItems.length} <FormattedMessage id={"wms.packing.articles"}/>
                </span>
                )}
            </Grid>

            <Grid
                container
                direction={'row'}
                gap={"8px"}
            >
                <Badge
                    size={'large'}
                    rounded
                    color={'info'}
                    isBold={false}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <CarrierIcon shippingMethod={packingStep.selectedShipment.shippingMethod}/>
                        {packingStep.selectedShipment.shippingMethod.name}
                    </div>
                </Badge>

                {currentWorkstation && packingStepNames.PACK_ITEMS === packingStep.stepName && (
                    <Badge
                        size={'large'}
                        rounded
                        color={'info'}
                        isBold={false}
                    >
                        {currentWorkstation.name}
                    </Badge>
                )}

                {isMultiSessionPacking && (
                    <Badge
                        color={"online"}
                        rounded
                        size={"large"}
                        label={<FormattedMessage id={"wms.packing.item.multiSessionPacking.notice"}/>}
                    />
                )}
            </Grid>
        </Grid>
    );
}

export default ShipmentInfosHeader;
